import { createSelector } from 'reselect'
import * as last from 'lodash/last'
import { State } from 'interfaces/state'
import { NavigationAppState } from 'interfaces/navigation'
import { DASHBOARD_URL } from 'tangle-shared'

export const navigationSelector = (state: State): NavigationAppState => state.app.navigation

export const previousUrlSelector = createSelector(
  navigationSelector,
  (navigation) => last(navigation.previousUrls) || DASHBOARD_URL
)

export const previousUrlsSelector = createSelector(
  navigationSelector,
  ({ previousUrls }) => previousUrls
)

export const canGoBackSelector = createSelector(
  navigationSelector,
  (_state: State, props: { pathname: string }) => props.pathname,
  ({ previousUrls }, pathname) => previousUrls.length > 1 || previousUrls[0] !== pathname
)
